/* unplugin-vue-components disabled */import script from "./excel-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./excel-modal.vue?vue&type=script&setup=true&lang=js"

import "./excel-modal.vue?vue&type=style&index=0&id=2589f342&lang=scss"

const __exports__ = script;

export default __exports__